export default __webpack_public_path__ + "static/media/sandbox.704af34c.svg";